import _ from 'lodash';
import * as React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { hasAnyRole, Roles } from './permissions.helper';

const CODIGO_BLOQUEIO = 'CLIENTE_EM_INVENTARIO';

function textoDoErro(data) {
  if (!data) return '';
  if (typeof data === 'string') return data;

  const mensagem =
    _.get(data, 'mensagem') ||
    _.get(data, 'message') ||
    _.get(data, 'error') ||
    _.get(data, 'detalhe');

  if (mensagem) return mensagem;

  try {
    return JSON.stringify(data);
  } catch (e) {
    return '';
  }
}

export function obterBloqueioInventario(error) {
  const data = _.get(error, 'response.data');
  const texto = textoDoErro(data);
  const codigo = _.get(data, 'codigo');
  const identificado =
    codigo === CODIGO_BLOQUEIO || texto.indexOf(CODIGO_BLOQUEIO) >= 0;

  if (!identificado) return null;

  return {
    codigo: CODIGO_BLOQUEIO,
    mensagem:
      _.get(data, 'mensagem') ||
      _.get(data, 'message') ||
      'O cliente está em período de inventário. Esta ação não pode ser realizada neste período.',
    podeContinuar:
      _.get(data, 'podeContinuar') === true ||
      hasAnyRole([Roles.ADMIN, Roles.SUDO]),
  };
}

/**
 * Executa uma operação e, caso o backend bloqueie por inventário, pergunta se
 * o usuário autorizado deseja repetir a mesma operação com o bypass explícito.
 * Retorna { inventarioBloqueado: true } quando o usuário não pode ou não quis
 * continuar, evitando que cada tela mostre uma segunda mensagem de erro.
 */
export function executarComConfirmacaoInventario(acao, entidade) {
  return acao(entidade).catch((error) => {
    const bloqueio = obterBloqueioInventario(error);
    if (!bloqueio) return Promise.reject(error);

    return new Promise((resolve, reject) => {
      confirmAlert({
        customUI: ({ onClose }) => {
          const finalizarSemRepetir = () => {
            onClose();
            resolve({ inventarioBloqueado: true });
          };

          const continuar = () => {
            onClose();

            if (!bloqueio.podeContinuar) {
              resolve({ inventarioBloqueado: true });
              return;
            }

            acao({ ...entidade, continuarDuranteInventario: true })
              .then(resolve)
              .catch(reject);
          };

          return (
            <div className="custom-confirm-alert">
              <h2>Período de inventário</h2>
              <p>{bloqueio.mensagem}</p>
              {bloqueio.podeContinuar ? (
                <p>
                  A ação será realizada somente porque seu perfil tem
                  permissão para continuar.
                </p>
              ) : null}
              <div className="d-flex justify-content-around mt-4">
                {bloqueio.podeContinuar ? (
                  <button
                    className="btn btn-secondary btn30 white"
                    onClick={finalizarSemRepetir}
                  >
                    Cancelar
                  </button>
                ) : null}
                <button className="btn btn-danger btn30" onClick={continuar}>
                  {bloqueio.podeContinuar ? 'Continuar mesmo assim' : 'OK'}
                </button>
              </div>
            </div>
          );
        },
      });
    });
  });
}

